/**
 * Created by Анжелика on 21.06.2017.
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';

class ErrorBlock extends Component {
    render() {
        const {error_description} = this.props;
        return (
            <div className="error-block">
                <div className="alert alert-danger">
                    <p>{error_description}</p>
                </div>
            </div>
        )
    }
}

ErrorBlock.propTypes = {
    error_description: PropTypes.string.isRequired
};

export default ErrorBlock;


// WEBPACK FOOTER //
// ./src/components/ErrorBlock.js